export enum CriterionType {
    Size = 1,
    Consideration = 2,
    Other = 3,
    Custom = 4,
}